import { Form } from "antd";

import type { FormFieldFactoryProps } from "../../types/types";
import { Textarea } from "./Textarea";

export const TextareaField = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <Textarea key={field.name} name={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
